import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ENTITIES } from '../constants/entities';

function JobList({ role, filiale }) {
  const [jobs, setJobs] = useState([]);
  const [filterFiliale, setFilterFiliale] = useState('');
  const [filterType, setFilterType] = useState('');
  const navigate = useNavigate();

  const contractTypes = ['CDI', 'CDD', 'Contractuel', 'Stage', 'Alternance', 'Freelance'];

  // Récupération des offres depuis l’API
  useEffect(() => {
  const fetchJobs = async () => {
    try {
      // 🔁 Récupération de toutes les offres
      const res = await axios.get(`${process.env.REACT_APP_DOMAINE}/api/jobs`);
      const allJobs = res.data;

      const isGlobalAdmin = ['admin', 'ceo'].includes(role);

      // ✅ Cas 1 : si une filiale est spécifiée → on filtre par filiale même pour les CEO
      if (filiale) {
        const filtered = allJobs.filter((job) => job.filiale === filiale);
        setJobs(filtered);
      }
      // ✅ Cas 2 : admin général sur le dashboard global → on affiche tout
      else if (isGlobalAdmin) {
        setJobs(allJobs);
      }
      // ✅ Cas 3 : fallback — un manager ou un autre cas → on filtre aussi
      else {
        const filtered = allJobs.filter((job) => job.filiale === filiale);
        setJobs(filtered);
      }
    } catch (err) {
      console.error("Erreur récupération des offres :", err.message);
    }
  };

  // 🔁 Exécuter à chaque changement de rôle ou filiale ciblée
  fetchJobs();
}, [role, filiale]);


  // 🔍 Filtrage des offres affichées
  const filteredJobs = jobs.filter((job) => {
    const matchesFiliale = !filterFiliale || job.filiale === filterFiliale;
    const matchesType = !filterType || job.type_contrat === filterType;
    return matchesFiliale && matchesType;
  });

  // Supprimer une offre
  const handleDelete = async (id) => {
    const job = jobs.find(j => j.id === id);
    const confirmMsg = `⚠️ Voulez-vous vraiment supprimer l'offre "${job?.title}" ?\n\nCette action est irréversible et supprimera :\n- L'offre d'emploi\n- Toutes les candidatures liées\n- Les fichiers des candidats associés`;

    if (!window.confirm(confirmMsg)) return;

    try {
      await axios.delete(`${process.env.REACT_APP_DOMAINE}/api/jobs/${id}`);
      setJobs((prev) => prev.filter((job) => job.id !== id));
      alert(`✅ L'offre "${job?.title}" a été supprimée avec succès.`);
    } catch (err) {
      console.error("Erreur suppression :", err.message);
      alert(`❌ Erreur lors de la suppression : ${err.response?.data?.error || err.message}`);
    }
  };


  return (
    <div className="mt-4">
      <h4>💼 Offres d'emploi</h4>

      {/* 🔍 Filtres - Only show on dashboard, not on filiale view */}
      {!filiale && (
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Filtrer par filiale</label>
            <select
              className="form-select"
              value={filterFiliale}
              onChange={(e) => setFilterFiliale(e.target.value)}
            >
              <option value="">-- Toutes les entités --</option>
              {ENTITIES.map((entity) => (
                <option key={entity} value={entity}>
                  {entity}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">Filtrer par type de contrat</label>
            <select
              className="form-select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="">-- Tous les types --</option>
              {contractTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {filteredJobs.length === 0 ? (
        <p>Aucune offre trouvée avec ces filtres.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Titre</th>
                <th>Contrat</th>
                <th>Ville</th>
                <th>Pays</th>
                <th>Filiale</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredJobs.map((job) => (
                <tr key={job.id}>
                  <td data-label="Titre">{job.title}</td>
                  <td data-label="Contrat">{job.type_contrat}</td>
                  <td data-label="Ville">{job.ville}</td>
                  <td data-label="Pays">{job.pays}</td>
                  <td data-label="Filiale">{job.filiale}</td>
                  <td data-label="Actions">
                    <button
                      className="btn btn-sm btn-warning me-2"
                      onClick={() => navigate(`/edit-job/${job.id}`)}
                    >
                      Modifier
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(job.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default JobList;
